const GET_DISPOSITION_CHOICE = 'GET_DISPOSITION_CHOICE';
const SET_DISPOSITION_CHOICE = 'SET_DISPOSITION_CHOICE';
const GET_DISPOSITION_SUB_CHOICE = 'GET_DISPOSITION_SUB_CHOICE';
const SET_DISPOSITION_SUB_CHOICE = 'SET_DISPOSITION_SUB_CHOICE';

export {
    GET_DISPOSITION_CHOICE,
    SET_DISPOSITION_CHOICE,
    GET_DISPOSITION_SUB_CHOICE,
    SET_DISPOSITION_SUB_CHOICE
};
